<template>
  <div class="content">
    <v-card>
      <v-card-title>
        <v-flex class="mt-2">
          <v-row justify="center">
            <v-flex xs12 md3 sm3>
              <v-col align="start">
                <span>UseCar Points</span>
              </v-col>
            </v-flex>

            <v-flex xs12 md9 sm9>
              <v-col align="end">
                <v-row justify="end">
                  <v-btn
                    class="success white--text mt-1"
                    @click="modalNewUsecarPointsPlans()"
                    >CRIAR NOVO TIPO</v-btn
                  >

                  <v-btn
                    class="ma-0 info white--text ml-5 mt-1 mr-5"
                    @click="modalNewUsecarPoints()"
                    >VINCULAR PLANO À UM CLIENTE</v-btn
                  >
                </v-row>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-title>
    </v-card>

    <v-card class="my-4">
      <v-card-title>
        Planos UseCar Points
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="usecar_points"
          class="elevation-1"
          no-data-text="Nenhum plano cadastrado"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.usecar_points_plans.name }}</td>
              <td class>{{ item.usecar_points_plans.description }}</td>
              <td class>{{ item.client_id }}</td>
              <td class>{{ item.points }}</td>
              <td class>{{ item.created_at | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        Saldo usuários UseCar Points
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers_balance"
          :items="usecar_points_balance"
          class="elevation-1"
          no-data-text="Nenhum plano cadastrado"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.user.name }}</td>
              <td class>{{ item.user.cpf }}</td>
              <td class>{{ item.points }}</td>
              <td class style="cursor: pointer; color: #2f5293">
                Ver histórico
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- MODAL ATRELAR CLIENTE AO USECARPOINTS PLAN-->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="register_usecar_points" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Atrelar cliente à um plano</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-layout align-baseline>
                    <v-autocomplete
                      multiple
                      persistent-hint
                      class="input mr-5"
                      :menu-props="{ maxHeight: '400' }"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      label="Clientes"
                      v-model="usecar_point.clients"
                    ></v-autocomplete>
                    <div class="buttons">
                      <v-btn
                        small
                        class="mb-2"
                        color="primary"
                        @click="selectAllClients()"
                        >Selecionar todos</v-btn
                      >
                      <v-btn
                        v-if="usecar_point.clients.length > 0"
                        x-small
                        color="error"
                        @click="removeAllClients()"
                        >Remover todos</v-btn
                      >
                    </div>
                  </v-layout>
                  <v-select
                    v-model="usecar_point.plan_id"
                    :items="usecar_points_plans"
                    item-text="name"
                    item-value="id"
                    label="Plano"
                    required
                  ></v-select>
                  <v-text-field
                    label="Pontos"
                    class="input"
                    v-model="usecar_point.points"
                  ></v-text-field>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="register_usecar_points = false"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click="send()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <!-- MODAL NEW USECAR POINTS PLAN-->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="register_plans" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Criar novo tipo</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-text-field
                    label="Nome"
                    class="input"
                    v-model="usecar_point_plan.name"
                  ></v-text-field>
                  <v-text-field
                    label="Descrição"
                    class="input"
                    v-model="usecar_point_plan.description"
                  ></v-text-field>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="register_plans = false"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click="sendPlan()"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import ClientController from '../../controllers/ClientController';
import UsecarPointsController from '../../controllers/UsecarPointsController';
import UsecarPointsBalanceController from '../../controllers/UsecarPointsBalanceController';
import UsecarPointsPlansController from '../../controllers/UsecarPointsPlansController';
import moment from 'moment';

export default {
  mounted() {
    this.getClients();
    this.getUsecarPoints();
    this.getUsecarPointsBalance();
    this.getUsecarPointsPlans();
  },

  data() {
    return {
      usecarPointsController: new UsecarPointsController(this.$resource),
      usecarPointsBalanceController: new UsecarPointsBalanceController(
        this.$resource
      ),
      usecarPointsPlansController: new UsecarPointsPlansController(
        this.$resource
      ),
      clientController: new ClientController(this.$resource),
      clients: [],
      register_usecar_points: false,
      register_plans: false,
      usecar_points_plans: [],
      usecar_points_balance: [],
      usecar_points: [],
      usecar_point: {
        clients: [],
        plan_id: null,
        points: null,
      },
      usecar_point_plan: {
        name: '',
        description: '',
      },
      headers: [
        { text: 'Nome', value: 'usecar_point_plans.name' },
        { text: 'Descrição', value: 'usecar_point_plans.description' },
        { text: 'Cliente', value: 'client_id' },
        { text: 'Pontos', value: 'points' },
        { text: 'Criado em', value: 'created_at' },
      ],
      headers_balance: [
        { text: 'Nome', value: 'user.name' },
        { text: 'CPF', value: 'user.cpf' },
        { text: 'Pontos', value: 'points' },
        { text: 'Ações', value: 'actions' },
      ],
    };
  },

  methods: {
    async getUsecarPointsPlans() {
      try {
        const res = await this.usecarPointsPlansController.get();
        this.usecar_points_plans = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async getUsecarPoints() {
      try {
        const res = await this.usecarPointsController.get();
        this.usecar_points = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async getUsecarPointsBalance() {
      try {
        const res = await this.usecarPointsBalanceController.getAll();
        this.usecar_points_balance = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    getClients() {
      this.clientController
        .getAllClients()
        .then(clients => (this.clients = clients));
    },

    async send() {
      try {
        const res = await this.usecarPointsController.send(this.usecar_point);
        this.$awn.success(`Plano de usecar points atrelado aos usuários.`);
        this.register_usecar_points = false;
        this.getUsecarPoints();
        this.clearForm();
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    async sendPlan() {
      try {
        const res = await this.usecarPointsPlansController.send(
          this.usecar_point_plan
        );
        this.$awn.success(`Plano de usecar points criada.`);
        this.register_plans = false;
        this.getUsecarPointsPlans;
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    modalNewUsecarPoints() {
      this.register_usecar_points = true;
    },

    modalNewUsecarPointsPlans() {
      this.register_plans = true;
    },

    selectAllClients() {
      this.usecar_point.clients = this.clients.map(client => client.id);
    },

    removeAllClients() {
      this.usecar_point.clients = [];
    },

    clearForm() {
      this.usecar_point = {
        clients: [],
        type: '',
        description: '',
        points: null,
      };
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
    },
  },
};
</script>

<style>
.container {
  max-width: 100%;
}
.input {
  width: 600px;
}
.buttons {
  display: flex;
  flex-direction: column;
}
</style>
